// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_zZKAW","clearfix":"reset_clearfix_OYe-A"};